<div class="container-fluid mt-4">
  <div class="mb-3">
    <button class="btn btn-secondary" (click)="navigateToConfiguration()">
      <i class="bi bi-arrow-left me-2"></i>Zurück zur Konfiguration
    </button>
  </div>

  <div *ngIf="isLoading()" class="text-center">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Laden...</span>
    </div>
  </div>

  <div *ngIf="errorMessage()" class="alert alert-danger" role="alert">
    {{ errorMessage() }}
  </div>

  <div *ngIf="!isLoading() && currentConfig()">
    <div class="alert alert-info mb-3">
      <strong>Aktuelles Modell:</strong> {{ currentConfig()?.model_name }}
    </div>

    <form [formGroup]="testForm">
      <div class="d-flex gap-2 mb-3">
        <button
          type="button"
          class="btn btn-primary cursor-pointer"
          (click)="onGenerate()"
          [disabled]="testForm.invalid || isGenerating()"
        >
          <span *ngIf="isGenerating()" class="spinner-border spinner-border-sm me-2"></span>
          <i *ngIf="!isGenerating()" class="bi bi-play-fill me-2"></i>
          Alle generieren
        </button>
        <button
          type="button"
          class="btn btn-secondary"
          (click)="resetTest()"
          [disabled]="isGenerating()"
        >
          <i class="bi bi-arrow-clockwise me-2"></i>
          Zurücksetzen
        </button>
      </div>

      @for (i of [1, 2, 3]; track i) {
        <app-input-response
          [inputNumber]="i"
          [formGroup]="testForm"
          [controlName]="'input' + i"
          [response]="getResponseForInput(i)"
          [isGenerating]="isGenerating()"
          (generateResponse)="generateResponse(i)"
        ></app-input-response>
      }
    </form>
  </div>
</div>
